import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

interface CTARowProps {
  showPacketReview?: boolean;
}

const CTARow = ({ showPacketReview = true }: CTARowProps) => {
  const scrollToKit = () => {
    document.querySelector("#kit-section")?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToTemplates = () => {
    document
      .querySelector("#templates-section")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="py-8 bg-gradient-to-r from-muted/30 via-background to-muted/30">
      <div className="container-custom">
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Button variant="gold" size="lg" onClick={scrollToKit}>
            Get the Complete DIY Kit ($99)
          </Button>
          <Button variant="outline" size="lg" onClick={scrollToTemplates}>
            Shop Templates
          </Button>
          {showPacketReview && (
            <Link to="/packet-review">
              <Button variant="ghost" size="lg" className="text-muted-foreground">
                Packet Review
                <ArrowRight className="w-4 h-4 ml-1" />
              </Button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default CTARow;
